
import { Bot } from "lucide-react";

export const Welcome = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">
      <div className="flex items-center gap-2 sm:gap-4 md:gap-6 mb-4 sm:mb-6 md:mb-8">
        <span className="font-inter font-bold text-2xl sm:text-3xl md:text-4xl text-blue-400">
          AX
        </span>
        <h1 className="text-xl sm:text-3xl md:text-4xl font-bold tracking-tight text-white">
          Hi! I'm AnalystX
        </h1>
      </div>
      <div className="space-y-2 max-w-xs sm:max-w-sm md:max-w-md mx-auto">
        <p className="text-sm sm:text-base md:text-lg text-gray-400">
          Your AI-powered market research assistant.
        </p>
        <p className="text-base sm:text-lg md:text-xl text-gray-400">
          I can help with industry analysis, market trends, and vendor analysis
        </p>
      </div>
    </div>
  );
};

const SuggestionButton = ({ text }: { text: string }) => {
  return (
    <button className="p-3 border border-gray-300 rounded-xl text-gray-800 text-sm text-left hover:bg-gray-50 transition-colors">
      {text}
    </button>
  );
};
